import { gql } from '@apollo/client';

import { TLaunchDarklySet } from '../../../../store/LaunchDarkly';
import { IMachineDetails } from '../../../../store/MachineDetails';

import { TQueryResponse } from '../../../types';

import { client } from '../../graphql';

export const getFleetDevice = async (launchDarkly: TLaunchDarklySet, fleetDeviceId: string) => {
  const imagesEnabled = launchDarkly['machine-image-upload'];
  const notesEnabled = launchDarkly['machine-notes'];
  const configurationEnabled = launchDarkly['configuration-details-enabled'];
  const locale = localStorage.getItem('locale-id') ?? 'en_GB';
  const { data } = await client(launchDarkly).query<TQueryResponse<'fleetDevice', IMachineDetails>>({
    query: gql`
      query FleetDevice($fleetDeviceId: ID!) {
        fleetDevice(fleetDeviceId: $fleetDeviceId) {
          id
          type
          account {
            id
            name
          }
          ${
            notesEnabled
              ? `notes {
            id
            title
            description
            author {
              id
              salutation
              firstName
              lastName
              profilePicture
            }
            updateDateTime
          }`
              : ''
          }
          brand {
            id
            name
            isAgco
          }
          brandText
          subCategory {
            defaultDisplayName
            key
            category {
              defaultDisplayName
              key
            }
          }
          modelSeries {
            name
          }
          modelSeriesText
          model {
            name
            id
            modelSeries {
              name
            }
            ${
              imagesEnabled
                ? `images {
              url
              thumbnails {
                SIZE_319_319
                SIZE_48_48
                SIZE_140_100
              }
            }`
                : ''
            }
          }
          categoryText
          subCategoryText
          modelText
          image
          modelVariant {
            name
            id
            ${
              imagesEnabled
                ? `images {
              url
              thumbnails {
                SIZE_319_319
                SIZE_48_48
                SIZE_140_100
              }
            }`
                : ''
            }
          }
          ${
            imagesEnabled
              ? `images {
            url
            thumbnails {
              SIZE_319_319
              SIZE_48_48
              SIZE_140_100
            }
          }`
              : ''
          }
          modelVariantText
          name
          vin
          ownershipStartDate
          ownershipStatus
          yearOfManufacture
          condition
          pspDetails {
            vin
            pspCode
            pspDescription
            pspStartDate
            pspEndDate
            claimNumber
            repairDate
            claimStatus
          }
          ${
            configurationEnabled
              ? `configurationDetails {
                  vin
                  groups {
                    code
                    description
                    descriptionTranslated
                    options {
                      code
                      characteristics
                      description
                      shortDescription
                      shortDescriptionTranslated
                    }
                  }
              }`
              : ''
          }
        }
      }
    `,
    variables: { fleetDeviceId },
    context: configurationEnabled
      ? {
          headers: {
            'x-agco-device-config-details-locale': locale,
          },
        }
      : undefined,
  });
  return data.fleetDevice;
};
